/**
 * NoteSymbolLayer Component
 *
 * Interaction-only — attaches the note-pin click handler to the layer
 * owned by `UnifiedAnchorSymbolLayer` (which renders the note pin off the
 * unified `map-cluster-source`). `NoteSymbolPresenter` stays exported for
 * `NoteMiniMap`, which keeps its own non-clustered source.
 *
 * Click semantics live in the shared `useMapLayerClick` primitive — cursor
 * is owned by `useMapMarkerHoverPreview` so both task and note layers
 * share a single canvas-cursor writer.
 *
 * @module components/map/NoteSymbolLayer/NoteSymbolLayer
 */

import { memo, type RefObject } from 'react';
import type { MapRef } from '@vis.gl/react-maplibre';

import { useMapLayerClick } from '@/components/map/hooks/useMapLayerClick';

import { NOTE_LAYER_IDS } from './styles/noteSymbolLayerStyles';

// ===== Types =====

interface NoteSymbolLayerProps {
  mapRef: RefObject<MapRef | null>;
  isMapReady: boolean;
}

// ===== Component =====

export const NoteSymbolLayer = memo(function NoteSymbolLayer({
  mapRef,
  isMapReady,
}: NoteSymbolLayerProps) {
  useMapLayerClick({
    mapRef,
    isMapReady,
    layerId: NOTE_LAYER_IDS.MARKER_PIN,
    artifactKind: 'notes',
  });

  return null;
});
